export default __webpack_public_path__ + "static/alex-d25f84c2dcafd3a333a8b957b806f1b2.jpg";